'use client';

function getFloatingValue(value, precision) {
  return parseFloat(value.toFixed(precision));
}
export { getFloatingValue };